export const channels = [
    {
      uuid: "16fdfefe-e466-4090-bc1a-57c43937f826",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "96aaf72c-b5ed-4ce4-937d-1912e4f8bf0d",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "06d3366b-9ec2-46e8-a741-df3ee1abeed7",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "b51689be-8eb4-4481-b208-6bbcb7fb47c2",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "b95dc0e8-93d6-473e-a0ce-839d988b1dcf",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "359563a3-3bbb-40f7-8a55-bec3b11180c4",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "21dda491-f640-4db5-9172-d35eedd06ea5",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "d75873f4-4f2c-46f6-b6d6-65cfa62b8cf7",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "a7238d3d-f1e6-4934-a663-37c1902920cd",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "da5fc532-fa14-481b-91c7-0c8bc4ee91a3",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "bbd592e8-bd97-4889-915d-3c4b14788cfb",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "371ffac1-a5cd-4702-96b7-a35eba5edd7d",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "834bed5f-5b88-46cd-bb04-0c2cd208bccb",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    },
    {
      uuid: "faf1be3a-ec39-43ab-86c4-37f3e59c2a7a",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "5b61a5f3-314f-4e8b-ae90-4fca1f75a322",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "eb202e9d-15ee-4bce-a1a8-31067e761a13",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "ea11bc6c-5108-4aab-b52e-37ac3ab7aec9",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "abb06f7d-cfc9-4b9e-9c4b-f68b49bb79f9",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "f3cd7461-202c-41d3-858a-f5313c873ca6",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "93fd7dc6-ef9c-41c8-bc6d-d2b99714a81c",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "dda97845-3014-4076-a95a-45ace93066fa",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "160cf7f7-5362-4e60-b826-cc737bc33a64",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "827d2bd6-7ca2-4ace-a413-c4e0eecad5d6",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "1e04ef2d-b361-4869-b77a-17448579ee93",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "7edbc4fb-c507-40cc-9247-7321ed8c7c63",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "1099f860-f237-411a-81f3-30ed257a3b7c",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    },
    {
      uuid: "5a8415aa-4974-4669-86ed-9858aa6713c5",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "400acec5-40de-4f0b-8a0c-7bbbc35dfb7d",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "cd93d7ca-8593-48ca-8343-12d30cc4451a",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "1e6dfec0-efb8-4c75-8985-0db6fbaa197b",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "aecaa82f-febc-426e-8dfd-96e0f0dc08c8",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "36097986-3928-411c-aa78-0f47ee416b30",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "ace99d29-47a2-4c39-9749-8cf6cbc5bc30",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "eb7e69f5-89a2-48fe-b435-74d362a1866e",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "49fbe5c1-77a0-4ed6-aa08-7fd572a32430",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "70cc9f20-3c0b-4938-978f-4a5375e14f13",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "7b31a72e-152b-4562-9ad2-8db9b6f3c750",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "8693e9d0-eea3-41fd-80aa-d3956701aa12",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "cf8a9542-41e1-4aad-8414-fbe2cd94b17a",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    },
    {
      uuid: "539571b9-6c0a-4f70-af33-2f546281e003",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "5a2aa5d3-b751-4c43-a4fc-ed76e81bcd2e",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "23c37d13-a0a3-44f9-afd2-332893408e84",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "e7b529cb-52a7-4bcb-a71e-28c2fd5eeff8",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "ab0d438e-35b5-4514-af3c-84e75ae5e92e",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "d5a845fc-a413-4a41-8985-ede7e8f089dc",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "0dd9db77-60d5-44ab-9348-c9a058c3bcbb",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "85cd75e7-2f82-4247-8579-69c000ba1b08",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "331eb7f2-724f-4c09-9de9-e20d0492b135",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "8edbe62c-ad08-4bdd-85cd-afbdf8e42cac",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "2c67c688-22f4-4a47-ba32-324bc03ccab9",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "3062a287-f7d6-47f4-88b6-83f28aca44f6",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "690ad50a-411a-484b-9811-d328c4d4398d",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    },
    {
      uuid: "6abd107f-56d3-4786-b1b1-4c9e162a65cd",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "9adba5b9-3abf-4809-9b51-61aebfb29a8a",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "92459776-748c-41ef-8d3a-c34006b4372f",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "f2968385-dd98-4171-9d75-f62d893ef582",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "de3c4ff9-f8be-471a-ab72-6b2e1e2228d0",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "9f87ae78-7df2-4c7d-9e61-8c3eb4e6c4a0",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "bc174bc9-e935-4efb-9d41-c672cd775025",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "cbbdb962-dbbf-4941-8343-1983d5879359",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "2c7ea360-76ce-4cda-8385-bc5979657806",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "a6f5a53e-f408-4da9-b8f9-f1d35fbb50cb",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "0bf252fd-6f88-4672-a570-53edc2fe5415",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "f459e709-4656-4745-b717-4b4d0d1b2659",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "7cc9c216-7b00-49e5-8263-94e943704a12",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    },
    {
      uuid: "e8fb4033-8f05-4985-876c-e45cfb51ffa1",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "73026ffe-71e9-46c6-9838-d5c38b551e1e",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "b510ac02-b972-4a47-9d26-1592ac230935",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "39b5f4bb-9037-47c5-846f-0494e62c244a",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "7c576004-da44-40b1-9659-5550fe058739",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "1026b6c1-afe9-4965-a3b9-3a8a819b7d29",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "c42abe0a-c470-4101-9548-64dd2a7756d8",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "cd9c83a8-4f81-4151-ace9-d2bfb9102989",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "8b617dfa-8ce0-47c2-b520-d7401b0696f6",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "9c5e2c94-6ca0-47ab-9349-f205478d7de7",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "8ca6fed2-4ea3-49a8-95f2-25c10b043907",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "714c99f2-3955-4dce-9fcf-17c1eb41096d",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "a5dcee5a-bdb8-4533-ba03-b2142fbbb813",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    },
    {
      uuid: "09a21c96-6d3a-46db-93ed-d72c9dc5766b",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "c3fe7731-0eef-4726-9522-9accff8a4213",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "e1a3dafd-5679-4871-b98a-46cebcbb046e",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "6557fc44-881a-4828-8898-8dcf571ef058",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "5fa3b7cd-cd12-4a12-98b2-c3113b12e2f1",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "19ad2010-47fb-43e1-8bad-1ba460f3832a",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "2453628b-d5ff-446a-8c7a-1e64a67f714c",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "d88d30cc-9e1b-4c3d-a0a7-4525cf790236",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "5cdf4c75-c14a-4554-bd69-27c29dde56b4",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "3676e52b-5b72-4316-b95d-c4f25804e345",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "dc37d14d-c672-4a96-a561-1d2a72fa7e0a",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "052ae4e6-7578-4e6d-a617-54981f81702c",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "2aa6537c-d2fe-4456-a006-9fe1e5451b2a",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    },
    {
      uuid: "a76180a7-fce6-4a57-b96e-9bc49076cbcc",
      type: "channel",
      title: "r tv",
      country: "USA",
      provider: 7427,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/r-channel.png",
      year: 2002
    },
    {
      uuid: "71fd1c67-a89b-4005-a7d6-5b7b62fd9949",
      type: "channel",
      title: "b tv",
      country: "USA",
      provider: 2764,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/b-channel.png",
      year: 2002
    },
    {
      uuid: "7eb49524-b38c-4731-b5f8-77ab665e4423",
      type: "channel",
      title: "five tv",
      country: "USA",
      provider: 9749,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/five-channel.png",
      year: 2002
    },
    {
      uuid: "e3dd2990-564e-4906-ba1f-d6568f756e4f",
      type: "channel",
      title: "comedy tv",
      country: "USA",
      provider: 5066,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/c-channel.png",
      year: 2002
    },
    {
      uuid: "3b961a46-5eb3-4299-9f84-5f1e8e411e99",
      type: "channel",
      title: "tm tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/tm-channel.png",
      year: 2002
    },
    {
      uuid: "836cf4d0-f911-4580-a98b-05bd4b977e3b",
      type: "channel",
      title: "w tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/w-channel.png",
      year: 2002
    },
    {
      uuid: "c437886a-9ab7-4ac6-903d-cbc5704363bd",
      type: "channel",
      title: "six tv",
      country: "USA",
      provider: 703,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/six-channel.png",
      year: 2002
    },
    {
      uuid: "67d23273-0c91-4fb5-a41c-f92bca521559",
      type: "channel",
      title: "nfi tv",
      country: "USA",
      provider: 8851,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/nfi-channel.png",
      year: 2002
    },
    {
      uuid: "bce0c96e-d5fa-4a8f-8b65-1837da688918",
      type: "channel",
      title: "dragon tv",
      country: "USA",
      provider: 4447,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/dragon-channel.png",
      year: 2002
    },
    {
      uuid: "cb4bdac4-cae9-4e07-ad48-1c67ecd59deb",
      type: "channel",
      title: "cd tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/cd-channel.png",
      year: 2002
    },
    {
      uuid: "b4307adf-7e59-486e-8b36-62dbe7d96c1b",
      type: "channel",
      title: "tennis tv",
      country: "USA",
      provider: 563,
      logo:
        "https://github.com/karolkozer/planby-demo-resources/blob/master/resources/channel-logos/png/tennis-ball-channel.png?raw=true",
      year: 2002
    },
    {
      uuid: "0fb4db54-1377-441c-a422-bf10ba7e2678",
      type: "channel",
      title: "bowling tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/bowling-channel.png",
      year: 2002
    },
    {
      uuid: "2c0ea47e-22a9-46cb-8986-290d5502b748",
      type: "channel",
      title: "movie tv",
      country: "USA",
      provider: 5380,
      logo:
        "https://raw.githubusercontent.com/karolkozer/planby-demo-resources/master/resources/channel-logos/png/movie-channel.png",
      year: 2002
    }
  ];
  